import { useEffect, useRef, useState } from 'react';

export function useThrottledCallback(callback, ms) {
    const [throttled, setThrottled] = useState(false);
    const timer = useRef();
    useEffect(() => () => clearTimeout(timer.current), []);
    return [
        function() {
            callback.apply(null, arguments);
            setThrottled(true);
            clearTimeout(timer.current);
            timer.current = setTimeout(() => setThrottled(false), ms);
        },
        throttled
    ];
}
